
import React from 'react';
// import PropTypes from 'prop-types';
import { RadioGroup, FormControlLabel, Radio } from '@material-ui/core';

const renderCheckbox = ({ value, Radiogroup, changeData,valueData, input }) => (
    <div>
      <RadioGroup aria-label="position" name="position"  onChange={changeData} row {...input} >
        {
            Radiogroup.map( r => {
                return <FormControlLabel
                            key = {r.id}
                            value={r.value}
                            control={<Radio color="primary" />}
                            label={r.label}
                            labelPlacement="start"
                        />
            })
        }
      </RadioGroup>
    </div>
);

/* renderCheckbox.propTypes = {
     
}; */

export default renderCheckbox;